document.addEventListener("DOMContentLoaded", function() {
  var mapElement = document.getElementById('map_canvas');

  if(!!mapElement) {
    var latitude = mapElement.dataset.latitude;
    var longitude = mapElement.dataset.longitude;

    var myLatLng = new google.maps.LatLng(parseFloat(latitude), parseFloat(longitude));
    var isDraggable = !('ontouchstart' in document.documentElement);

    var directionsLink = '<a href="https://maps.google.com?saddr=Current+Location&daddr=' + latitude + ',' + longitude + '" target="_blank">Click Here for Directions</a>';

    var infowindow = new google.maps.InfoWindow({
      content: directionsLink
    });

    var map = new google.maps.Map(mapElement, {
      center: myLatLng,
      zoom: 8,
      draggable: isDraggable,
      scrollwheel: false,
    });

    var marker = new google.maps.Marker({
      position: myLatLng,
      map: map
    });

    marker.addListener('click', function() {
      infowindow.open(map, marker);
    });

    google.maps.event.addListener(map, 'click', function(event){
      this.setOptions({ scrollwheel: true });
    });
  }
});
